// LocationFormUI.tsx
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import { Business } from "0.Mine/3.Interfaces/business";

import { SafeArgonSelect } from "./PlatformFormUI";

interface LocationFormUIProps {
  location: Partial<Business>;
  onFieldChange: (field: keyof Partial<Business>, value: string | boolean) => void;
}

const LocationFormUI: React.FC<LocationFormUIProps> = ({ location, onFieldChange }) => {
  const { t } = useTranslation();

  const countries = [
    t("countries.AD"),
    t("countries.AE"),
    t("countries.AF"),
    t("countries.AG"),
    t("countries.AI"),
    t("countries.AL"),
    t("countries.AM"),
    t("countries.AO"),
    t("countries.AQ"),
    t("countries.AR"),
    t("countries.AS"),
    t("countries.AT"),
    t("countries.AU"),
    t("countries.AW"),
    t("countries.AX"),
    t("countries.AZ"),
    t("countries.BA"),
    t("countries.BB"),
    t("countries.BD"),
    t("countries.BE"),
    t("countries.BF"),
    t("countries.BG"),
    t("countries.BH"),
    t("countries.BI"),
    t("countries.BJ"),
    t("countries.BL"),
    t("countries.BM"),
    t("countries.BN"),
    t("countries.BO"),
    t("countries.BQ"),
    t("countries.BR"),
    t("countries.BS"),
    t("countries.BT"),
    t("countries.BV"),
    t("countries.BW"),
    t("countries.BY"),
    t("countries.BZ"),
    t("countries.CA"),
    t("countries.CC"),
    t("countries.CD"),
    t("countries.CF"),
    t("countries.CG"),
    t("countries.CH"),
    t("countries.CI"),
    t("countries.CK"),
    t("countries.CL"),
    t("countries.CM"),
    t("countries.CN"),
    t("countries.CO"),
    t("countries.CR"),
    t("countries.CU"),
    t("countries.CV"),
    t("countries.CW"),
    t("countries.CX"),
    t("countries.CY"),
    t("countries.CZ"),
    t("countries.DE"),
    t("countries.DJ"),
    t("countries.DK"),
    t("countries.DM"),
    t("countries.DO"),
    t("countries.DZ"),
    t("countries.EC"),
    t("countries.EE"),
    t("countries.EG"),
    t("countries.EH"),
    t("countries.ER"),
    t("countries.ES"),
    t("countries.ET"),
    t("countries.FI"),
    t("countries.FJ"),
    t("countries.FK"),
    t("countries.FM"),
    t("countries.FO"),
    t("countries.FR"),
    t("countries.GA"),
    t("countries.GB"),
    t("countries.GD"),
    t("countries.GE"),
    t("countries.GF"),
    t("countries.GG"),
    t("countries.GH"),
    t("countries.GI"),
    t("countries.GL"),
    t("countries.GM"),
    t("countries.GN"),
    t("countries.GP"),
    t("countries.GQ"),
    t("countries.GR"),
    t("countries.GS"),
    t("countries.GT"),
    t("countries.GU"),
    t("countries.GW"),
    t("countries.GY"),
    t("countries.HK"),
    t("countries.HM"),
    t("countries.HN"),
    t("countries.HR"),
    t("countries.HT"),
    t("countries.HU"),
    t("countries.ID"),
    t("countries.IE"),
    t("countries.IL"),
    t("countries.IM"),
    t("countries.IN"),
    t("countries.IO"),
    t("countries.IQ"),
    t("countries.IR"),
    t("countries.IS"),
    t("countries.IT"),
    t("countries.JE"),
    t("countries.JM"),
    t("countries.JO"),
    t("countries.JP"),
    t("countries.KE"),
    t("countries.KG"),
    t("countries.KH"),
    t("countries.KI"),
    t("countries.KM"),
    t("countries.KN"),
    t("countries.KP"),
    t("countries.KR"),
    t("countries.KW"),
    t("countries.KY"),
    t("countries.KZ"),
    t("countries.LA"),
    t("countries.LB"),
    t("countries.LC"),
    t("countries.LI"),
    t("countries.LK"),
    t("countries.LR"),
    t("countries.LS"),
    t("countries.LT"),
    t("countries.LU"),
    t("countries.LV"),
    t("countries.LY"),
    t("countries.MA"),
    t("countries.MC"),
    t("countries.MD"),
    t("countries.ME"),
    t("countries.MF"),
    t("countries.MG"),
    t("countries.MH"),
    t("countries.MK"),
    t("countries.ML"),
    t("countries.MM"),
    t("countries.MN"),
    t("countries.MO"),
    t("countries.MP"),
    t("countries.MQ"),
    t("countries.MR"),
    t("countries.MS"),
    t("countries.MT"),
    t("countries.MU"),
    t("countries.MV"),
    t("countries.MW"),
    t("countries.MX"),
    t("countries.MY"),
    t("countries.MZ"),
    t("countries.NA"),
    t("countries.NC"),
    t("countries.NE"),
    t("countries.NF"),
    t("countries.NG"),
    t("countries.NI"),
    t("countries.NL"),
    t("countries.NO"),
    t("countries.NP"),
    t("countries.NR"),
    t("countries.NU"),
    t("countries.NZ"),
    t("countries.OM"),
    t("countries.PA"),
    t("countries.PE"),
    t("countries.PF"),
    t("countries.PG"),
    t("countries.PH"),
    t("countries.PK"),
    t("countries.PL"),
    t("countries.PM"),
    t("countries.PN"),
    t("countries.PR"),
    t("countries.PS"),
    t("countries.PT"),
    t("countries.PW"),
    t("countries.PY"),
    t("countries.QA"),
    t("countries.RE"),
    t("countries.RO"),
    t("countries.RS"),
    t("countries.RU"),
    t("countries.RW"),
    t("countries.SA"),
    t("countries.SB"),
    t("countries.SC"),
    t("countries.SD"),
    t("countries.SE"),
    t("countries.SG"),
    t("countries.SH"),
    t("countries.SI"),
    t("countries.SJ"),
    t("countries.SK"),
    t("countries.SL"),
    t("countries.SM"),
    t("countries.SN"),
    t("countries.SO"),
    t("countries.SR"),
    t("countries.SS"),
    t("countries.ST"),
    t("countries.SV"),
    t("countries.SX"),
    t("countries.SY"),
    t("countries.SZ"),
    t("countries.TC"),
    t("countries.TD"),
    t("countries.TF"),
    t("countries.TG"),
    t("countries.TH"),
    t("countries.TJ"),
    t("countries.TK"),
    t("countries.TL"),
    t("countries.TM"),
    t("countries.TN"),
    t("countries.TO"),
    t("countries.TR"),
    t("countries.TT"),
    t("countries.TV"),
    t("countries.TW"),
    t("countries.TZ"),
    t("countries.UA"),
    t("countries.UG"),
    t("countries.UM"),
    t("countries.US"),
    t("countries.UY"),
    t("countries.UZ"),
    t("countries.VA"),
    t("countries.VC"),
    t("countries.VE"),
    t("countries.VG"),
    t("countries.VI"),
    t("countries.VN"),
    t("countries.VU"),
    t("countries.WF"),
    t("countries.WS"),
    t("countries.YE"),
    t("countries.YT"),
    t("countries.ZA"),
    t("countries.ZM"),
    t("countries.ZW"),
  ];

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        {t("Inserisci il tuo indirizzo")}
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("Via, numero civico, etc")}
          </InputLabel>
          <TextField
            fullWidth
            value={location.address || ""}
            onChange={(e) => onFieldChange("address", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("Codice di Avviamento Postale")}
          </InputLabel>
          <TextField
            fullWidth
            value={location.postalCode || ""}
            onChange={(e) => onFieldChange("postalCode", e.target.value)}
          />
        </Grid>
        <Grid item xs={6}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("Città")}
          </InputLabel>
          <TextField
            fullWidth
            value={location.city || ""}
            onChange={(e) => onFieldChange("city", e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel required sx={{ mb: 1 }}>
            {t("Nazione")}
          </InputLabel>
          <FormControl fullWidth>
            <Select
              value={location.country || ""}
              onChange={(e) => onFieldChange("country", e.target.value)}
              displayEmpty
              MenuProps={{
                PaperProps: {
                  style: { maxHeight: 300 },
                },
              }}
              renderValue={(selected) => {
                return selected || t("onboarding.selectCountry");
              }}
            >
              {countries.map((country) => (
                <MenuItem key={country} value={country}>
                  {country}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <InputLabel sx={{ mb: 1 }}>Provincia</InputLabel>
          <TextField
            fullWidth
            placeholder={t("onboarding.selectProvince")}
            value={location.province || ""}
            onChange={(e) => onFieldChange("province", e.target.value)}
          />
        </Grid>
        <Grid item xs={12}>
          {/*<FormControlLabel
                        control={
                            <Checkbox
                                checked={Boolean(location.locationHidden)}
                                onChange={(e) => onFieldChange('locationHidden', e.target.checked)}
                            />
                        }
                        label={t('onboarding.hidelocation')}
                    />*/}
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(location.onqlickplace)}
                onChange={(e) => onFieldChange("onqlickplace", e.target.checked)}
              />
            }
            label={"Vuoi pubblicare questa location su QlickPlace, il nostro marketplace?"}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Checkbox
                checked={Boolean(location.isFranchise)}
                onChange={(e) => onFieldChange("isFranchise", e.target.checked)}
              />
            }
            label={"Questa sede fa parte di un franchising"}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default LocationFormUI;
